import React, {useState} from "react";
import {Box, Typography, Menu, MenuItem, IconButton, ListItemIcon, ListItemText, useTheme, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper} from "@mui/material";
import VisibilityIcon from "@mui/icons-material/Visibility";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import CustomChipComponent from "../../../core/components/common/custom-chip.component";
import moment from "moment";
import {useNavigate, useLocation} from "react-router-dom";
import BorderColorIcon from "@mui/icons-material/BorderColor";
import UpdateIcon from "@mui/icons-material/Update";
import UpdateStatusDialog from "./update-status.dialog";
import { useGuard } from "../../RBACPlugin";
import { permissions } from "../../../core/components/common/variables/static_variables";

const CustomMenuPopperComponent = (props) => {
    const {data, setSelectedBooking, setOpen, theme, customIconStyles, organizationId} = props;

    const navigate = useNavigate();
    const {hasPermission} = useGuard();

    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);

    
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    }
    
    const handleClose = () => {
        setAnchorEl(null);
    }

    const handleUpdateStatus = (e) => {
        setSelectedBooking(data);
        setOpen(true);
    }

    const handleViewDetails = (e, data) => {
        if (organizationId) {
            navigate(`/organization/view/bookings/view?org_uid=${organizationId}&id=${data.booking_uid}`);

        } else {
            navigate(`/bookings/view?id=${data.booking_uid}`);
        }
    }

    const handleEditBooking = (e, data) => {
        if (organizationId) {
            navigate(`/organization/view/bookings/edit?org_uid=${organizationId}&id=${data.booking_uid}`);

        } else {
            navigate(`/bookings/edit?id=${data.booking_uid}`);
        }
    }

    const menuItems = [
        {
            icon: <VisibilityIcon fontSize="small" sx={{color: theme.palette.primary.main}} />,
            label: "View Details",
            onClick: (e) => handleViewDetails(e, data),
            requiredPermission: permissions.booking.VIEW_BOOKING,
        },
        {
            icon: <BorderColorIcon fontSize="small" sx={{color: theme.palette.primary.main}} />,
            label: "Edit Booking",
            onClick: (e) => handleEditBooking(e, data),
            requiredPermission: permissions.booking.UPDATE_BOOKING,
        },
         {
            icon: <UpdateIcon fontSize="small" sx={{color: theme.palette.primary.main, fontSize: 23}} />,
            label: "Update Status",
            onClick: (e) =>  handleUpdateStatus(e),
            requiredPermission: permissions.booking.CHANGE_STATUS_BOOKING,
        }
    ].filter((item) => hasPermission(item.requiredPermission))

    
    return (
        <>
            {
                menuItems.length > 0 &&
                <>
                    <IconButton onClick={handleClick}>
                        <MoreVertIcon />
                    </IconButton>
        
                    <Menu
                        anchorEl={anchorEl}
                        open={open}
                        onClose={handleClose}
                        PaperProps={{style: {maxHeight: 300}}}
                    >
                        {menuItems?.map((item, index) => (
                            <MenuItem
                                key={index}
                                onClick={() => {
                                    handleClose();
                                    item.onClick();
                                }}
                                sx={{}}
                            >
                                <ListItemIcon sx={customIconStyles}>
                                    {item.icon}
                                </ListItemIcon>
                    
                                <ListItemText sx={{ml: "-3px"}} primary={item.label} />
                            </MenuItem>
                        ))}
                    </Menu>
                </>
            }
        </>
    )
}

const ListBookingComponent = (props) => {
    const {headers, data, isMobile, breakpoints} = props;

    const theme = useTheme();
    const location = useLocation();

    const [open, setOpen] = useState(false);
    const [selectedBooking, setSelectedBooking] = useState();

    const organizationId = new URLSearchParams(location.search).get("org_uid");
    

    return (
        <Paper elevation={0} sx={{width: "100%", overflow: "hidden", border: "1px solid #e5edf6", boxShadow: "none", borderRadius: 1}}>
            <TableContainer>
                <Table>
                    <TableHead sx={{backgroundColor: "inherit", color: "inherit"}}>
                        <TableRow>
                            {headers.map((header, index) => (
                                <TableCell
                                    key={index}
                                    align="start"
                                    sx={{color: theme.typography.secondary, fontWeight: 600}}
                                >
                                    {header}
                                </TableCell>
                            ))}                   
                        </TableRow>
                    </TableHead>

                    <TableBody>
                        {data?.length > 0 ? (
                            data?.map((booking) => (
                                <TableRow key={booking.id}>
                                    <TableCell component="th" scope="row" sx={{color: theme.typography.primary, fontWeight: 600}}>
                                        {booking.booking_type}
                                    </TableCell>

                                    <TableCell component="th" scope="row" sx={{color: theme.typography.primary}}>
                                        {booking.purpose}
                                    </TableCell>

                                    <TableCell component="th" scope="row" sx={{color: theme.typography.primary}}>
                                        <Box>
                                            <Typography sx={{color: theme.typography.primary, fontSize: 14}}>
                                                {moment(booking.valid_from).format("MM/DD/YYYY")} - {moment(booking.valid_to).format("MM/DD/YYYY")}
                                            </Typography>
                                        </Box>
                                    </TableCell>

                                    <TableCell component="th" scope="row">
                                        <CustomChipComponent category="bookingStatus"
                                            label={(booking.status === "Draft") ? "Draft" 
                                                : 
                                                    (booking.status === "Pending for Approval") ? "Pending for Approval"
                                                :
                                                    (booking.status === "Scheduled") ? "Scheduled"
                                                :
                                                    (booking.status === "Cancelled") ? "Cancelled"
                                                :
                                                    (booking.status === "Overdue") ? "Overdue"
                                                :
                                                    (booking.status === "Completed") ? "Completed"
                                                :
                                                    (booking.status === "Rejected") ? "Rejected"
                                                :
                                                    booking.status
                                            }
                                        />
                                    </TableCell>

                                    <TableCell align="start">
                                        <CustomMenuPopperComponent 
                                            data={booking} 
                                            setSelectedBooking={setSelectedBooking}
                                            setOpen={setOpen} 
                                            theme={theme}
                                            organizationId={organizationId}
                                        />
                                    </TableCell>
                                </TableRow>
                            ))
                        ) : (
                            <TableRow>
                                <TableCell colSpan={headers?.length} align="center">
                                    No booking data available to display
                                </TableCell>
                            </TableRow>
                        )}
                    </TableBody>
                </Table>
            </TableContainer>

            {open && 
                <UpdateStatusDialog 
                    open={open} 
                    setOpen={setOpen} 
                    selectedBooking={selectedBooking}
                />
            }
        </Paper>
    )
}

export default ListBookingComponent